import { ConfigurationParametersValuesService_parameterServiceGetEntitiescsv } from '@festina/life-general-types/life/hooks/ConfigurationParametersValuesService_parameterServiceGetEntitiescsv'
import type { Optional } from '@festina-life/core'
import { useMutation } from '@tanstack/react-query'

import { useLayoutContext } from '../../../context/layoutContext'
import { useParameterDefinitionId } from '../../../hooks/useParameterDefinitionId'
import { useStandardService } from '../../../hooks/useStandardService'
import { useNavigationParams } from '../../../system/useNavigationParams'

const path =
  ConfigurationParametersValuesService_parameterServiceGetEntitiescsv.path

export const useLazyFetchParameterValuesCsv = () => {
  const { layer } = useNavigationParams()
  const service = useStandardService()
  const parameterDefinitionId = useParameterDefinitionId()
  const {
    preferences: {
      parameters: { isFlattened },
    },
  } = useLayoutContext()

  return useMutation({
    mutationFn: async (atDate: Optional<string>) => {
      const headers = new Headers()
      const token =
        typeof service.api.OpenAPI.TOKEN === 'string'
          ? service.api.OpenAPI.TOKEN
          : await service.api.OpenAPI.TOKEN!({
              method: 'POST',
              url: path,
            })

      if (layer.tenantId) {
        // TODO: Add proper layering support once the standard service supports it
        headers.append('x-tenant-id', layer.tenantId)
      }
      headers.append('authorization', `Bearer ${token}`)
      headers.append('accept', 'text/plain')
      headers.append('Content-Type', 'text/plain')

      const request: RequestInit = {
        headers,
        method: 'GET',
      }

      const searchParams = new URLSearchParams({
        secondaryId: parameterDefinitionId,
        flattened: `${isFlattened}`,
        ...(atDate ? { at: atDate } : {}),
      })
      const response = await fetch(
        `${service.api.OpenAPI.BASE}${path}?${searchParams.toString()}`,
        request,
      )

      return response.text()
    },
  })
}
